<template>
  <section>
    <v-card class="table-container">
      <template>
        <v-data-table :headers="headers" :items="productsFeatured" :search="search" sort-by="name">
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="section-title">Produtos em Destaque</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Procurar"
                class="mr-2 mb-4"
                single-line
                hide-details
              ></v-text-field>
              
              <v-btn 
                color="#90A99C"
                fab
                dark
                small
                class="plus-btn mb-2 mr-2"
                @click="export_excel(productsFeatured)"
              >
                <v-icon>mdi mdi-download</v-icon>
              </v-btn>

              <v-dialog v-model="dialog" max-width="500px">
                <template v-slot:activator="{ on }">
                  <v-btn @click="createItem()" color="primary" fab dark small class="plus-btn mb-2" v-on="on">
                    <v-icon>mdi mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="title-form headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="editedItem.g_product_id"
                            :items="products"
                            item-value="g_product_id"
                            item-text="name"
                            label="Produtos"
                          ></v-select>
                        </v-col>

                        <v-col cols="12">
                          <v-text-field label="Glintt Product ID" :id="editedItem.id+'_g_product_id'" v-model="editedItem.g_product_id"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <p>{{productMsg}}</p>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="mr-0 mb-2" x-small outlined fab @click="close">
                      <v-icon>mdi mdi-close</v-icon>
                    </v-btn>
                    <v-btn color="primary" class="mr-2 mb-2" x-small fab @click="save(editedItem)">
                      <v-icon>mdi mdi-content-save</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn x-small depressed fab dark color="#7E1416" @click="deleteProductsFeatured(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
    </v-card>
  </section>
</template>

<script>
import {json2excel} from 'js2excel'

export default {
  name: "Produtos",
  data: () => ({
    search: '',
    dialog: false,
    headers: [
      { text: "ID", align: "start", sortable: true, value: "id" },
      { text: "Glintt product ID", sortable: true, value: "g_product_id" },
      { text: "Nome Produto", sortable: true, value: "name" },
      { text: "Acções", value: "actions", align: "end", sortable: false }
    ],
    products: [],
    productsFeatured: [],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    estado: "",
    productMsg: "",
    createResult: {},
    updateResult: {},

    image_1: [],
    image_2: [],
    image_3: [],
    video: [],
    form_data: new FormData(),
    categories: [],
    families: [],

    link_1: [],
    link_2: [],
    link_3: [],
    link_4: [],
    link_5: []

  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nova Produto" : "Editar Produto";
    }
  },

  watch: {
    dialog(val) {
      if(val == false) {
        this.close()
        this.productMsg = ""
        this.form_data = new FormData()
        this.editedItem = {}
        this.image_1 = []
        this.image_2 = []
        this.image_3 = []
        this.video = []
        
        this.link_1 = []
        this.link_2 = []
        this.link_3 = []
        this.link_4 = []
        this.link_5 = []
      }
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    export_excel: async function(data) {
      try {
          json2excel({
              data,
              name: 'products-list',
              formateDate: 'yyyy-mm-dd'
          });
      } catch (e) {
        alert('export error');
      }
    },
    async initialize() {
      await this.$store.dispatch('collectProductsFeatured', this)
      await this.$store.dispatch('collectCategories', this)
      await this.$store.dispatch('collectFamilies', this)
    },

    createItem() {
      this.$store.dispatch('collectProducts', this)
    },

    editItem(item) {
      this.editedIndex = this.products.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.estado = "editar";
    },

    async deleteProductsFeatured(item) {
        if (!confirm("Tem a certeza que pretende remover este produto dos Destaques?")){
        return
        }

        this.deletedItem = item

        this.deletedItem.featured = 0

        await this.$store.dispatch("deleteProductsFeatured", this); 
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save(editedItem) {
        if (editedItem.g_product_id) {
          await this.$store.dispatch("updateProductsFeatured", this)
        } 
    }
  }
};
</script>
